import { render, staticRenderFns } from "./_general-report-with-last-offers.component.vue?vue&type=template&id=2ea3dc9b&scoped=true"
import script from "./_general-report-with-last-offers.component.vue?vue&type=script&lang=js"
export * from "./_general-report-with-last-offers.component.vue?vue&type=script&lang=js"
import style0 from "./_general-report-with-last-offers.component.vue?vue&type=style&index=0&id=2ea3dc9b&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2ea3dc9b",
  null
  
)

export default component.exports